const SiteConfigEnum = {
  APARTMENT_SITE: 1,
  CONASI_SITE: 2,
  TROPICANA_SITE: 3,
  APOLLO_SITE: 4
}
export default SiteConfigEnum


// WEBPACK FOOTER //
// ./src/enum/siteConfigEnum.js